<ion-app>
    <router-outlet></router-outlet>
</ion-app>
